import { createAction } from '@reduxjs/toolkit'

const startInitialization = createAction(`startInitialization`)
export { startInitialization }
